import { render, staticRenderFns } from "./Import_Garantias.vue?vue&type=template&id=7b86d732"
import script from "./Import_Garantias.vue?vue&type=script&lang=js"
export * from "./Import_Garantias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports